import { api } from "./core/api";
import { Cookie } from "./core/Cookie";
import { Elements } from "./core/Elements";
import { popError } from "./core/Popup";
import { AudioSection } from "./sections/AudioSection";
import { VideoSection } from "./sections/VideoSection";
import { ImageSection } from "./sections/ImageSection";
import { HeadingSection } from "./sections/HeadingSection";
import { HtmlSection } from "./sections/HtmlSection";
import { SpotifySection } from "./sections/SpotifySection";
import { YoutubeSection } from "./sections/YoutubeSection";
import { AddMenu } from "./AddMenu";
import { AdminMenu } from "./admin/AdminMenu";
import { HtmlData } from "./data/HtmlData";
import { ImagesData } from "./data/ImagesData";
import { MediaData } from "./data/MediaData";
import { StreamsData } from "./data/StreamsData";

interface PageInterface {
    pagename: string;
    pagetitle: string;
    canedit: boolean;
    public: boolean;
    isAdmin: boolean;
    sections: Array<HtmlData | ImagesData | MediaData | StreamsData>;
}

export class Page {

    private addMenu: AddMenu;
    private adminMenu: AdminMenu;
    private isPublic: boolean;

    public constructor() {
        this.isPublic = false;
        this.addMenu = new AddMenu;
        this.adminMenu = new AdminMenu;
    }

    async load(pagename: string = ''): Promise<void> {

        if (pagename != '') Cookie.pagename = pagename;
        pagename = Cookie.pagename

        const resp = await api<PageInterface>('pageLoad', {
            pagename: pagename,
            username: Cookie.username
        });
        if (!resp) {
            popError(`Kunde inte ladda sidan`);
            return;
        }

        this.isPublic = resp.public;
        const titleElememt = Elements.siteTitle;
        titleElememt.innerText = resp.pagetitle;
        titleElememt.setAttribute('data-pagename', resp.pagename);

        // Render recieved sections
        Elements.contentContainer.innerHTML = '';

        if (this.isPublic || resp.canedit || resp.isAdmin) {
            resp.sections.forEach((section: HtmlData | ImagesData | MediaData | StreamsData) => {
                let sec = null;
                try {
                    console.log(section);
                    switch (section.sectiontype) {
                        case 'text':
                        case 'heading':
                        case 'html':
                            switch (section.subtype) {
                                case 'heading': sec = new HeadingSection(section as HtmlData); break;
                                case '':
                                case 'text':
                                case 'html': sec = new HtmlSection(section as HtmlData); break;
                            }
                            break;

                        case 'audio':
                        case 'video':
                        case 'media':
                        case '  ':
                            switch (section.subtype) {
                                case 'audio': sec = new AudioSection(section as MediaData); break;
                                case 'video': sec = new VideoSection(section as MediaData); break;
                            }
                            break;

                        case 'image':
                        case 'images':
                            sec = new ImageSection(section as ImagesData);
                            break;

                        case 'spotify':
                        case 'youtube':
                        case 'stream':
                        case 'streams':
                            switch (section.subtype) {
                                case 'spotify': sec = new SpotifySection(section as StreamsData); break;
                                case 'youtube': sec = new YoutubeSection(section as StreamsData); break;
                            }
                            break;
                    }

                    if (sec) {
                        try {
                            sec.enableEdit = resp.canedit;
                            sec.render();
                        }
                        catch (err) {
                            console.error(err);
                            popError(`Kunde inte rendera sektion ${section.sectionid} av typ ${section.sectiontype}/${section.subtype}`);

                        }
                    }
                } catch (err) {
                    if (err instanceof SyntaxError) popError(
                        `In Section ${section.sectiontype}:${section.sectionid} error occured as "${err.message}"`);
                }

            });
        }

        if (resp.canedit && Elements.leftSidebar.querySelector('.addMenu') === null) this.addMenu.render();
        else this.addMenu.close();

        if (resp.isAdmin && Elements.leftSidebar.querySelector('.adminMenu') === null) this.adminMenu.render();
        else this.adminMenu.close();

        Elements.help.style.display = resp.canedit ? 'flex' : 'none';
        if (resp.canedit) Elements.help.classList.remove('hidden');
        else Elements.help.classList.add('hidden');

        Elements.contentContainer.firstElementChild?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest", });

    }

}
